import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction} from "../components/CustomToast/actions";

export const LOADED_RUBRIC_GROUPS = '[rubrics] Loaded Rubric groups';
export const LOADED_RUBRICS = '[rubrics] Loaded Rubrics';
export const LOADED_RUBRICS_PAGES = '[rubrics] Loaded pages';
export const LOADED_RUBRICS_TOTAL = '[rubrics] Loaded total';
export const LOADED_RUBRICS_CURRENT = '[rubrics] Loaded current';
export const LOADED_RUBRICS_LIMIT = '[rubrics] Loaded limit';

export const LoadRubricGroupsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Rubrics')))
        .then(() => MindsetsJsSDK().API.get('rubrics/groups', options))
        .then(response => {
            dispatch(LoadedRubricGroupsAction(response.items));
            dispatch(LoadedRubricsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedRubricsLimitAction(response.limit));
            dispatch(LoadedRubricsPagesAction(response.pages));
            dispatch(LoadedRubricsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedRubricGroupsAction = payload => ({
    type: LOADED_RUBRIC_GROUPS,
    payload
});
export const LoadedRubricsPagesAction = payload => ({
    type: LOADED_RUBRICS_PAGES,
    payload
});
export const LoadedRubricsTotalAction = payload => ({
    type: LOADED_RUBRICS_TOTAL,
    payload
});
export const LoadedRubricsCurrentAction = payload => ({
    type: LOADED_RUBRICS_CURRENT,
    payload
});
export const LoadedRubricsLimitAction = payload => ({
    type: LOADED_RUBRICS_LIMIT,
    payload
});

export const LoadRubricsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Rubrics')))
        .then(() => MindsetsJsSDK().API.get('rubrics', options))
        .then(response => {
            dispatch(LoadedRubricsAction(response.items));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedRubricsAction = payload => ({
    type: LOADED_RUBRICS,
    payload
});
export const CreateRubricAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating...')))
        .then(() => MindsetsJsSDK().API.post('rubrics', data, options))
        .then(() => dispatch(LoadingAction(false)));
};
export const UpdateRubricAction = (rubric_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Updating...')))
        .then(() => MindsetsJsSDK().API.put(`rubrics/${rubric_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};

export const LoadRubricPDFAction = (challenge_version_id, practice_identifier, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'One moment... we\'re building the rubric for you!')))
        .then(() => MindsetsJsSDK().API.get(`challenge_versions/${challenge_version_id}/practices/${practice_identifier}/rubric`, options));
};

export const ApproveRubricsAction = (practice_id, challenge_version_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Approving Rubrics')))
        .then(() => MindsetsJsSDK().API.patch(`rubrics/${practice_id}/challenge_versions/${challenge_version_id}/approve`, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const GetRubricPDFDataAction = (challenge_version_id, practice_identifier) => () => {
    return MindsetsJsSDK().API.get(`challenge_versions/${challenge_version_id}/practices/${practice_identifier}/rubric`, {buffer: true});
};
